"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _commonCta = require("@mmc/common-cta");
var _commonDialog = _interopRequireDefault(require("../styles/common-dialog.css"));
var _commonDialog2 = _interopRequireDefault(require("./common-dialog.props/common-dialog.defaultProps"));
var _commonDialog3 = _interopRequireDefault(require("./common-dialog.props/common-dialog.propTypes"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; } /**
 * ## CommonDialog - component
 *
 * Some really cool piece of description goes here.
 */ // We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps,
  handleNestedProp = dataUtils.handleNestedProp;
var CommonDialog = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(CommonDialog, _React$Component);
  // All components need a resourceType in order for AEM to be aware of its existance
  CommonDialog.resourceType = function resourceType() {
    return 'CommonDialog_1_0_0';
  };
  CommonDialog.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.isOpen !== undefined) {
      return _objectSpread(_objectSpread({}, state), {}, {
        isOpen: props.isOpen
      });
    }
    return null;
  };
  function CommonDialog(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.handleEsc = function (event) {
      if (event.key === "Escape") {
        if (_this.props.closeEvent) {
          _this.props.closeEvent();
        }
      }
    };
    _this.state = {
      isOpen: false
    };
    _this.closeEvent = props.closeEvent || _this.handleCloseClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = CommonDialog.prototype;
  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener("keydown", this.handleEsc);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener("keydown", this.handleEsc);
  };
  _proto.handleCloseClick = function handleCloseClick() {
    this.setState({
      isOpen: false
    });
  };
  _proto.render = function render() {
    var _this$props = this.props,
      data = _this$props.data,
      theme = _this$props.theme,
      defaultData = _this$props.defaultData,
      _this$props$linkEvent = _this$props.linkEvents,
      linkEvents = _this$props$linkEvent === void 0 ? [] : _this$props$linkEvent,
      children = _this$props.children;
    var isOpen = this.state.isOpen;
    console.log('dm- ', {
      children: children
    });
    // first we select the data from the larger query coming through
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);

    // destructure items off data that the component needs
    var links = componentData.links || [];
    if (children && children.length) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _commonDialog["default"].dialogWrapper + " " + (isOpen ? _commonDialog["default"].isOpen : ''),
        "aria-hidden": !isOpen,
        automation: "CommonDialog"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _commonDialog["default"].dialogBox + " " + _commonDialog["default"].xl
      }, children, /*#__PURE__*/_react["default"].createElement("button", {
        className: _commonDialog["default"].mmcIconCloseModal,
        onClick: this.closeEvent,
        type: "button"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _commonDialog["default"].srOnly
      }, "Close"))));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _commonDialog["default"].dialogWrapper + " " + (isOpen ? _commonDialog["default"].isOpen : ''),
      "aria-hidden": !isOpen,
      automation: "CommonDialog"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _commonDialog["default"].dialogBox
    }, /*#__PURE__*/_react["default"].createElement("h2", {
      className: theme.headingFive + " " + _commonDialog["default"].heading
    }, handleNestedProp(componentData, 'componentData.overlayCopy.title')), /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.bodyCopy + " " + _commonDialog["default"].copy
    }, handleNestedProp(componentData, 'componentData.overlayCopy.text')), /*#__PURE__*/_react["default"].createElement("div", {
      className: _commonDialog["default"].ctaWrapper
    }, links.map(function (link, i) {
      var linkData = _objectSpread({}, link);
      if (linkData.priority === null || linkData.priority === undefined || linkData.priority === ' ') {
        linkData.priority = i === 0 ? 'critical' : 'trivial';
      }
      if (linkEvents[i] !== undefined) {
        delete linkData.url;
        return /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
          key: i,
          data: linkData,
          clickEvent: linkEvents[i],
          theme: theme
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
        key: i,
        data: linkData,
        theme: theme
      });
    })), /*#__PURE__*/_react["default"].createElement("button", {
      className: _commonDialog["default"].mmcIconCloseModal,
      onClick: this.closeEvent,
      type: "button"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _commonDialog["default"].srOnly
    }, "Close"))));
  };
  return CommonDialog;
}(_react["default"].Component);
exports["default"] = CommonDialog;
CommonDialog.displayName = 'CommonDialog';
CommonDialog.defaultProps = {
  data: _commonDialog2["default"],
  defaultData: _commonDialog2["default"],
  theme: {}
};